export default "__VITE_ASSET__rAMuHjQp__"